// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__QWd6V","breadcrumbsContent":"Breadcrumbs_breadcrumbsContent__H_MCm","breadcrumbList":"Breadcrumbs_breadcrumbList__aYf9v"};